export const ROUTES = {
  root:               '/',
  measurements:       '/measurements',
  programmes:         '/programmes',
  documents:          '/documents',
  documentsReview:    (id: number | string) => `/documents/${id}/review`,
  community:          '/community',
  // The Coaches row's address, and no page's. It redirects to the first tab
  // the reader holds, and bounds which tab may be redirected to — a stale
  // layout naming something outside it is not followed.
  coachesRow:         '/coaches',
  coachesMine:        '/coaches/mine',
  coachesHistory:     '/coaches/history',
  coachListing:       '/coaches/listing',
  coachRequests:      '/coaches/requests',
  coachMembers:       '/coaches/members',
  // A child of the tab above, so it is governed by the same page key. The
  // registry rule is that a child route has none of its own.
  coachMember:        (userId: number | string) => `/coaches/members/${userId}`,
  profile:            '/profile',
  dataProviders:               '/data-providers',
  dataPermissions:    '/data-permissions',
  chat:               '/chat',
  agent:              '/agents',
  settings:           '/settings',

  // This organisation's own administration, under one prefix (V61). Nothing at
  // '/tenant': two sidebar rows live in there, so it is a section rather than a
  // row, and the sidebar has no Tenant row to click.
  tenantManage:                '/tenant/manage',
  tenantMembers:               '/tenant/members',
  tenantRoles:                 '/tenant/roles',
  tenantRolePermissions:       '/tenant/role-permissions',
  tenantProgrammes:            '/tenant/programmes',
  tenantProgrammeMeasurements: '/tenant/programme-measurements',
  tenantQuestionnaires:        '/tenant/questionnaires',

  // Nothing here for the five addresses these replaced ('/tenant-settings' and
  // four '/manage/*'). The route tree redirects them and nothing navigates to
  // them, so a constant would only be a second place for a dead path to live.

  admin:                   '/admin',
  adminGlobalRoles:        '/admin/global-roles',
  adminGlobalPermissions:  '/admin/global-permissions',
  adminRoles:              '/admin/roles',
  adminRolePermissions:    '/admin/role-permissions',
  adminTenants:            '/admin/tenants',
  adminOrganisations:      '/admin/organisations',
  adminUsers:              '/admin/users',
  adminDataProviders:      '/admin/data-providers',
  adminDocumentTypes:      '/admin/document-types',
  // Likewise: the row, and then its four screens.
  masterDataRow:           '/admin/master-data',
  masterDataMeasurements:  '/admin/master-data/measurements',
  masterDataUnits:         '/admin/master-data/units',
  masterDataMolarMasses:   '/admin/master-data/units/molar-masses',
} as const;
